<template>
  <div dir="rtl">
    <div class="d-flex flex-column innerpopup f14-l19 regular_text" ref="popup" dir="rtl">
      <div class="d-flex flex-column  f14-l19 bold" v-html="this.popup_data.applicable_campaigns.title" ></div>
      <ul class="campaigns-list">
        <li class="campaign-item" 
        v-for="(item,idx) in this.popup_data.applicable_campaigns.campaigns_list" 
        :key="idx" 
        v-html="item.description" />
       
      </ul>
      <a 
        v-if="this.popup_data.applicable_campaigns.terms_link"
        class="d-flex flex-column text-center f14-l19 red-link" 
        :href="this.popup_data.applicable_campaigns.terms_link"
        @click="openLink" >
        {{ this.popup_data.applicable_campaigns.terms_link_text }}
        </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    popup_data: Object
  },
  methods:{
    closePopup(e) {
      e.stopPropagation();
      this.$emit('close');
    },
    openLink(e){
      e.stopPropagation();
    }
  }
}
</script>

<style>
.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 20px;
  border: 1px solid #ccc;
  padding: 20px 20px;
  min-width: max-content;
  cursor: pointer;
}
.regular_text {
  color: #38383b;
}

.campaigns-list {
  text-align: right;
  list-style-type: disc;
  /* list-style-position: inside; */
  padding-right: 15px;
  margin: 5px 0 0 0;
}

.campaign-item {
  margin-bottom: 3px;
  line-height: 1.3;
}
</style>
